import React from 'react';
import { useLocalizedStrings } from './Localization';
import { AidKitLogo } from './Util';

export function SiteNotFound() {
  const L = useLocalizedStrings();
    
  return (
    <>
      <div className="d-flex justify-content-center p-3">
        <AidKitLogo width={300} />
      </div>
      <div className="d-flex justify-content-center">
        {L.this_site_does_not_exist}&nbsp;<a href="https://aidkit.org" title="AidKit">{L.click_here}</a>
      </div>
    </>
  );
}

export function PageNotFound() {
  const L = useLocalizedStrings();

  return (
    <div className="min-h-screen pt-16 pb-12 flex flex-col bg-indigo-100">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 flex justify-center">
          <AidKitLogo width={200} height={60} />
        </div>
        <div className="py-16">
          <div className="text-center">
            <p className="text-lg font-semibold uppercase tracking-wide">404</p>
            <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              {L.admin_panel.error_pages.not_found_page.title}
            </h1>
            <p className="mt-2 text-base text-gray-500">
              {L.admin_panel.error_pages.not_found_page.description}
            </p>
            <div className="mt-6">
              <a href="/" className="text-base font-medium text-indigo-600 hover:text-indigo-500">
                {L.unauthorized.back}<span aria-hidden="true"> &rarr;</span>
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
